import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

import { ChevronRight } from 'lucide-react';

export default function AdminLogin() {
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = async () => {
    if (!id || !pw) {
      setErrorMsg('아이디와 비밀번호를 모두 입력해주세요.');
      return;
    }

    try {
      const params = new URLSearchParams();
      params.append('id', id);
      params.append('pw', pw);

      const response = await axios.post('/admin/loginProc', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        withCredentials: true,
      });

      if (response.data.result === '성공') {
        sessionStorage.setItem('isLoggedIn', 'true');

        try {
          navigate('/admin/contact', { replace: true });
        } catch (e) {
          window.location.href = '/admin';
        }
      } else {
        setErrorMsg(response.data.result || '로그인에 실패했습니다.');
      }
    } catch (error) {
      console.error('로그인 실패:', error);
      setErrorMsg('로그인 요청 중 오류가 발생했습니다. 관리자에게 문의하세요.');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <>
      <section className="login_sec">
        <div className="wrap">
          <div className="RLogin">
            <div className="LoginTitle">
              크림봇 <br />
              관리자페이지
            </div>
            <div>
              <div className="remove">
                <input
                  type="text"
                  className="login_input"
                  id="ad_id"
                  name="ad_id"
                  placeholder="ID"
                  value={id}
                  onChange={(e) => setId(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
                <input
                  type="password"
                  className="pw_input"
                  id="ad_pw"
                  name="pw"
                  placeholder="PASSWORD"
                  value={pw}
                  onChange={(e) => setPw(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
                <button
                  type="button"
                  onClick={handleLogin}
                  className="goAjaxId"
                >
                  <ChevronRight className='adminChevronRight'></ChevronRight>
                </button>
              </div>
              {errorMsg && (
                <div
                  className="error-message"
                  style={{ color: 'red', marginTop: '10px' }}
                >
                  {errorMsg}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
